<template>
  <div class="animated fadeIn">
    <spot-prices/>

    <div class="row" style="padding-bottom: 15px;">
      <div class="col-xl-12">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a v-on:click="showInventory = false; showFeatured = false; showFavorite = true" v-bind:class="{ active: showFavorite }" class="nav-link" href="#">Favorites</a>
          </li>
          <li class="nav-item">
            <a v-on:click="showInventory = false; showFeatured = true; showFavorite = false" v-bind:class="{ active: showFeatured }" class="nav-link" href="#">Featured</a>
          </li>
          <li class="nav-item">
            <a v-on:click="showInventory = true; showFeatured = false; showFavorite = false" v-bind:class="{ active: showInventory }" class="nav-link" href="#">Inventory</a>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="showInventory" class="row">
      <div class="col-xl-12">
        <inventory-list v-bind:inventory_config="inventory_config"/>
      </div>
    </div>

    <div v-if="showFeatured" class="row">
      <div class="col-xl-12">
        <table class="table table-bordered table-striped table-sm table-text-no-wrap">
          <thead>
          <tr>
            <th>Featured Item</th>
            <th>Net Ava.</th>
            <th class="text-center">Bid</th>
            <th class="text-center">Ask</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in featured">
            <td class="align-middle">{{item.purchase_desc}}</td>
            <td class="align-middle">{{item.quantity_on_hand + item.quantity_on_order -item.quantity_on_sales_order}}</td>
            <td class="align-middle text-center">
              <button v-if="item.dnb" type="button" class="btn btn-primary" style="width: 140px;">
                Please Call
              </button>
              <button v-else="item.dnb" v-on:click="sellItem(index)" type="button" class="btn btn-primary" style="width: 140px;">
                {{item.price_bid | currency}}
                &nbsp;&nbsp;<i class="fa fa-plus-circle"></i>
                <br/>
                <span v-if="item.use_percent === 0">
                  {{(Math.sign(item.premium_bid)  === 1 || item.premium_bid === 0) ?'+':'-'}}{{'$' + Math.abs(item.premium_bid)}} {{item.melt_plus ? ' per piece' : ' per ounce'}} 
                </span>
              </button>
            </td>
            <td class="align-middle text-center">
              <button v-if="item.dns" type="button" class="btn btn-success" style="width: 140px;">
                Please Call
              </button>
              <button v-else="item.dns" v-on:click="buyItem(index)" type="button" class="btn btn-success" style="width: 140px;">
                {{item.price_ask | currency}}
                &nbsp;&nbsp;<i class="fa fa-plus-circle"></i>
                <br/>
                <span v-if="item.use_percent === 0">
                  {{(Math.sign(item.premium_ask)  === 1 || item.premium_ask === 0) ?'+':'-'}}{{'$' + Math.abs(item.premium_ask)}} {{item.melt_plus ? ' per piece' : ' per ounce'}}
                </span>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="showFavorite" class="row">
      <div class="col-xl-12">
        <table class="table table-bordered table-striped table-sm table-text-no-wrap">
          <thead>
          <tr>
            <th>Favorite Item</th>
            <th>Net Ava.</th>
            <th class="text-center">Bid</th>
            <th class="text-center">Ask</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in favorites">
            <td class="align-middle">{{item.purchase_desc}}</td>
            <td class="align-middle">{{item.quantity_on_hand + item.quantity_on_order -item.quantity_on_sales_order}}</td>
            <td class="align-middle text-center">
              <button v-if="item.dnb" type="button" class="btn btn-primary" style="width: 140px;">
                Please Call
              </button>
              <button v-else="item.dnb" v-on:click="sellItemFav(index)" type="button" class="btn btn-primary" style="width: 140px;">
                {{item.price_bid | currency}}
                &nbsp;&nbsp;<i class="fa fa-plus-circle"></i>
                <br/>
                <span v-if="item.use_percent === 0">
                  {{(Math.sign(item.premium_bid)  === 1 || item.premium_bid === 0) ?'+':'-'}}{{'$' + Math.abs(item.premium_bid)}} {{item.melt_plus ? ' per piece' : ' per ounce'}} 
                </span>
              </button>
            </td>
            <td class="align-middle text-center">
              <button v-if="item.dns" type="button" class="btn btn-success" style="width: 140px;">
                Please Call
              </button>
              <button v-else="item.dns" v-on:click="buyItemFav(index)" type="button" class="btn btn-success" style="width: 140px;">
                {{item.price_ask | currency}}
                &nbsp;&nbsp;<i class="fa fa-plus-circle"></i>
                <br/>
                <span v-if="item.use_percent === 0">
                  {{(Math.sign(item.premium_ask)  === 1 || item.premium_ask === 0) ?'+':'-'}}{{'$' + Math.abs(item.premium_ask)}} {{item.melt_plus ? ' per piece' : ' per ounce'}}
                </span>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal title="Announcement - Metal Market" class="modal-primary" ok-only size="lg" v-model="announcementModal" @ok="closeAnnouncement()">
      <div class="row">
        <div class="col-12">
          <h6>New Updates</h6>
          <br/>
          <table class="table table-bordered table-striped table-sm">
            <tbody>
              <tr>
                <td>
                  <div class="ql-editor" v-html='announcementContent'>
                  </div>
                </td>  
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
    <announcement></announcement>
  </div>
</template>

<script>
  import { pricing } from '../../components/mixins/pricing'
  import { Announcement } from '../../components/'

  export default {
    name: 'inventory',
    mixins: [pricing],
    components: {
      Announcement
    },
    data () {
      return {
        context: 'inventory context',
        inventory_config: {
          showFav: true,
          showName: true,
          showWeight: true,
          showInStock: false,
          // showQuantityLimiter: true,
          showOrdered: false,
          showSalesOrder: false,
          showPricing: false,
          showBid: false,
          showCost: false,
          showAsk: false,
          showBuy: true,
          showSell: true,
          pageSize: 10,
          customerFilter: true
        },
        featured: [],
        favorites: [],
        currentSpot: null,
        showInventory: false,
        showFeatured: false,
        showFavorite: true,
        announcementModal: false,
        announcementContent: ''
      }
    },
    watch: {
      favorites: function (newVal, oldVal) {
        this.priceItems()
      },
      featured: function (newVal, oldVal) {
        this.priceItems()
      },
      spot_prices: function (newVal, oldVal) {
        this.priceItems()
      }
    },
    methods: {
      buyItem (index) {
        document.body.classList.remove('aside-menu-hidden')
        this.$bus.$emit('buy-item', this.featured[index])
      },
      sellItem (index) {
        document.body.classList.remove('aside-menu-hidden')
        this.$bus.$emit('sell-item', this.featured[index])
      },
      buyItemFav (index) {
        document.body.classList.remove('aside-menu-hidden')
        this.$bus.$emit('buy-item', this.favorites[index])
      },
      sellItemFav (index) {
        document.body.classList.remove('aside-menu-hidden')
        this.$bus.$emit('sell-item', this.favorites[index])
      },
      getFeatured () {
        this.$http.get('inventory/featured').then(response => {
          this.featured = response.body
        }, response => {
          console.log(response)
        })
      },
      getFavorites () {
        this.$http.get('inventory/favorites').then(response => {
          this.favorites = response.body
        }, response => {
          console.log(response)
        })
      },
      priceItems () {
        for (var i = 0, len = this.featured.length; i < len; i++) {
          const currentPrice = this.priceItem(this.currentSpot, this.featured[i])
          this.featured[i].price_bid = currentPrice.bid
          this.featured[i].price_ask = currentPrice.ask
        }

        for (var j = 0, leng = this.favorites.length; j < leng; j++) {
          const currentPrice = this.priceItem(this.currentSpot, this.favorites[j])
          this.favorites[j].price_bid = currentPrice.bid
          this.favorites[j].price_ask = currentPrice.ask
        }
      },
      userCheckedIn (id) {
        this.$http.post('auth/setUpdate', {'id': id}).then(response => {
          console.log(response)
        }, response => {
          console.log(response)
        })
      },
      getAnnouncementDetails () {
        console.log('getAnnouncementDetails -> getAnnouncementDetails')
        this.$http.get('admin/announcement-content').then(response => {
          this.announcementContent = response.body[0]['setting_value']
          console.log('getAnnouncementDetails -> response.body', this.$auth.user())
        }, response => {
          console.log(response)
        })
      },
      closeAnnouncement () {
        this.announcementModal = false
        this.close()
      },
      close () {
        console.log('close method called')
        // this.userCheckedIn(this.$auth.user().id)
        // we are accessing the stored value.
        this.$auth.user().is_update = 0
      }
    },
    created () {
      this.$bus.$on('spot-price', ($event) => {
        if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
          this.currentSpot = $event
          if (this.featured.length === 0) {
            this.getFeatured()
          }
          if (this.favorites.length === 0) {
            this.getFavorites()
          }
        } else {
          this.$bus.$emit('request-spot-price')
        }
      })
      this.$bus.$on('favorite-item', ($event) => {
        this.getFavorites()
      })
    },
    beforeMount () {
      this.$bus.$emit('request-spot-price')
      console.log('beforeMount -> this.$auth.user()', this.$auth.user().is_update)
      // called when announcement is made
      if (this.$auth.user().is_update === 1) {
        this.announcementModal = true
        this.userCheckedIn(this.$auth.user().id)
        this.getAnnouncementDetails()
      } else {
        this.getAnnouncementDetails()
      }
    }
  }
</script>

<style>
  .table-text-no-wrap td {
    max-width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?57f05848